import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'DropDown'
})
export default class DropDown extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: true }) arrow!: boolean;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    open: boolean = false;

    dropdown(event: MouseEvent) {
        if (event.ctrlKey) {
            this.open = true;
        } else {
            this.open = !this.open;
        }
    }
}
